export default "/images/vendor/flag-icon-css/flags/1x1/sv.svg?dd3c991c109acb5525b19cf667bb630a";